__turbopack_context__.v({
  "description": "NhvQHa_description",
});
